import { render } from "./DiscordLogin.vue?vue&type=template&id=26e7fdba"
import script from "./DiscordLogin.vue?vue&type=script&lang=js"
export * from "./DiscordLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__